import { render } from "./ProductCategorySkeleton.vue?vue&type=template&id=77691180&scoped=true"
import script from "./ProductCategorySkeleton.vue?vue&type=script&lang=js"
export * from "./ProductCategorySkeleton.vue?vue&type=script&lang=js"

import "./ProductCategorySkeleton.vue?vue&type=style&index=0&id=77691180&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77691180"]])

export default __exports__